<template>
  <div class="light">
    <Header />
    <main id="main">
      <section id="referCont">
        <div class="container">
          <WrapTitle name1="REFERENCE" name2="BOOK" />
          <div class="refer__cont">
            <div class="table">
              <h3>HTML</h3>
              <ul>
                <li>
                  <a href="referDetail.html">
                    <span className="num">1</span>
                    <span className="attr">&lt;a&gt;</span>
                    <span className="desc"
                      >&lt;a&gt; 태그는 다른 페이지 이동을 설정합니다.</span
                    >
                    <span className="Inline">Inline Element</span>
                  </a>
                </li>
                <li>
                  <a href="referDetail.html">
                    <span className="num">2</span>
                    <span className="attr">&lt;abbr&gt;</span>
                    <span className="desc"
                      >&lt;abbr&gt; 태그는 다른 페이지 이동을 설정합니다.</span
                    >
                    <span className="Inline">Inline Element</span>
                  </a>
                </li>
                <li>
                  <a href="referDetail.html">
                    <span className="num">3</span>
                    <span className="attr">&lt;acronym&gt;</span>
                    <span className="desc"
                      >&lt;acronym&gt; 태그는 다른 페이지 이동을
                      설정합니다.</span
                    >
                    <span className="Inline">Inline Element</span>
                  </a>
                </li>
                <li>
                  <a href="referDetail.html">
                    <span className="num">4</span>
                    <span className="attr">&lt;address&gt;</span>
                    <span className="desc"
                      >&lt;address&gt; 태그는 다른 페이지 이동을
                      설정합니다.</span
                    >
                    <span className="Inline">Inline Element</span>
                  </a>
                </li>
                <li>
                  <a href="referDetail.html">
                    <span className="num">5</span>
                    <span className="attr">&lt;applet&gt;</span>
                    <span className="desc"
                      >&lt;applet&gt; 태그는 다른 페이지 이동을
                      설정합니다.</span
                    >
                    <span className="Inline">Inline Element</span>
                  </a>
                </li>
                <li>
                  <a href="referDetail.html">
                    <span className="num">6</span>
                    <span className="attr">&lt;area&gt;</span>
                    <span className="desc"
                      >&lt;area&gt; 태그는 이미지 맵의 영역을 정의합니다.</span
                    >
                    <span className="Inline">Inline Element</span>
                  </a>
                </li>
                <li>
                  <a href="referDetail.html">
                    <span className="num">7</span>
                    <span className="attr">&lt;article&gt;</span>
                    <span className="desc"
                      >&lt;article&gt; 태그는 사이트의 독립적인 컨텐츠 섹션을
                      설정합니다.
                    </span>
                    <span className="Inline">Inline Element</span>
                  </a>
                </li>
                <li>
                  <a href="referDetail.html">
                    <span className="num">8</span>
                    <span className="attr">&lt;aside&gt;</span>
                    <span className="desc"
                      >&lt;aside&gt; 태그는 주요 콘텐츠의 보조적 컨텐츠 섹션을
                      설정합니다</span
                    >
                    <span className="Inline">block Element</span>
                  </a>
                </li>
                <li>
                  <a href="referDetail.html">
                    <span className="num">9</span>
                    <span className="attr">&lt;audio&gt;</span>
                    <span className="desc"
                      >&lt;audio&gt; 태그는 오디오 파일을 설정합니다.</span
                    >
                    <span className="Inline">Inline Element</span>
                  </a>
                </li>
                <li>
                  <a href="referDetail.html">
                    <span className="num">10</span>
                    <span className="attr">&lt;b&gt;</span>
                    <span className="desc"
                      >&lt;b&gt; 태그는 다른 텍스트와 구별 할 때
                      설정합니다.</span
                    >
                    <span className="Inline">Inline Element</span>
                  </a>
                </li>
                <li>
                  <a href="referDetail.html">
                    <span className="num">11</span>
                    <span className="attr">&lt;base&gt;</span>
                    <span className="desc"
                      >&lt;base&gt; 태그는 모든 문서의 기본이 되는 URL을
                      설정합니다.</span
                    >
                    <span className="Inline">Inline Element</span>
                  </a>
                </li>
                <li>
                  <a href="referDetail.html">
                    <span className="num">12</span>
                    <span className="attr">&lt;basefont&gt;</span>
                    <span className="desc"
                      >&lt;basefont&gt; 태그는 문서의 기본 폰트, 사이즈, 종류를
                      설정합니다.</span
                    >
                    <span className="Inline">Inline Element</span>
                  </a>
                </li>
                <li>
                  <a href="referDetail.html">
                    <span className="num">13</span>
                    <span className="attr">&lt;a&gt;</span>
                    <span className="desc"
                      >&lt;a&gt; 태그는 다른 페이지 이동을 설정합니다.</span
                    >
                    <span className="Inline">Inline Element</span>
                  </a>
                </li>
                <li>
                  <a href="referDetail.html">
                    <span className="num">14</span>
                    <span className="attr">&lt;bdi&gt;</span>
                    <span className="desc"
                      >&lt;bdi&gt; 태그는 태그는 텍스트의 출력 방향 영역을
                      설정합니다.</span
                    >
                    <span className="Inline">Inline Element</span>
                  </a>
                </li>
                <li>
                  <a href="referDetail.html">
                    <span className="num">15</span>
                    <span className="attr">&lt;bdo&gt;</span>
                    <span className="desc"
                      >&lt;bdo&gt; 태그는 텍스트의 방향을 설정합니다.</span
                    >
                    <span className="Inline">Inline Element</span>
                  </a>
                </li>
                <li>
                  <a href="referDetail.html">
                    <span className="num">16</span>
                    <span className="attr">&lt;big&gt;</span>
                    <span className="desc"
                      >&lt;big&gt; 태그는 텍스트의 크기를 크게 설정합니다.</span
                    >
                    <span className="Inline">Inline Element</span>
                  </a>
                </li>
                <li>
                  <a href="referDetail.html">
                    <span className="num">17</span>
                    <span className="attr">&lt;blockquote&gt;</span>
                    <span className="desc"
                      >&lt;blockquote&gt; 태그는 긴 문장의 인용문을
                      설정합니다.</span
                    >
                    <span className="Inline">Inline Element</span>
                  </a>
                </li>
                <li>
                  <a href="referDetail.html">
                    <span className="num">18</span>
                    <span className="attr">&lt;blink&gt;</span>
                    <span className="desc"
                      >&lt;blink&gt; 태그는 다른 페이지 이동을 설정합니다.</span
                    >
                    <span className="Inline">Inline Element</span>
                  </a>
                </li>
                <li>
                  <a href="referDetail.html">
                    <span className="num">19</span>
                    <span className="attr">&lt;body&gt;</span>
                    <span className="desc"
                      >&lt;body&gt; 태그는 문서의 타이틀, 스크립트, 스타일, 메타
                      정보 등을 설정합니다.</span
                    >
                    <span className="Inline">Inline Element</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <!-- //referCont -->
      <ContInfo />
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import WrapTitle from '@/components/WrapTitle.vue';
import ContInfo from '@/components/ContInfo.vue';

export default {
  components: {
    Header,
    Footer,
    WrapTitle,
    ContInfo,
  },
};
</script>

<style lang="scss">
#referCont {
  background-color: #000;
  color: #fff;
  padding-bottom: 300px;
}
.refer__cont {
  .table {
    border-bottom: 2px solid #000;
    margin-top: 1.2rem;

    h3 {
      padding-bottom: 10px;
      display: inline-block;
      text-transform: uppercase;
      font-size: 1.5vw;
      margin: 10px 20px;
      cursor: pointer;

      &.active {
        border-bottom: 1px solid #fff;
      }
    }
    ul {
      border-top: 1px solid #fff;
    }
    li {
      margin: 0;
      list-style: none;
      border-bottom: 1px solid #fff;
      position: relative;
      transition: all 0.3s;
      overflow: hidden;

      &:hover {
        background: rgba(255, 255, 255, 0.1);
      }

      span {
        display: inline-block;
        float: left;
        padding: 25px 10px;
        font-size: 14px;
        font-family: 'S-CoreDream-3Light';
        box-sizing: border-box;

        &:nth-child(1) {
          width: 5%;
          text-align: center;
        }
        &:nth-child(2) {
          width: 10%;
        }
        &:nth-child(3) {
          width: 70%;
        }
        &:nth-child(4) {
          width: 15%;
        }
      }
    }
  }
}
</style>
